<template>
  <v-app>
    <!-- <Notification /> -->
    <AppHeader />
    <MobileHeader />
    <router-view
      style="min-height: 90vh"
      :key="$route.fullPath"
    />
    <AppFooter />
  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld';
import AppHeader from "./components/Common/appHeader";
import AppFooter from "./components/Common/appFooter";
import MobileHeader from "./components/Common/mobileHeader";
import "./assets/styles/fonts.css";
import "./assets/styles/styles.css";
// import Notification from "./components/Common/notification";
export default {
  name: "App",

  components: {
    AppHeader,
    AppFooter,
    MobileHeader,
    // Notification,
    // HelloWorld,
  },

  data: () => ({
    //
  }),
};
</script>
<style>
.itemHeading {
  font-family: brandonBold;
  font-size: 24px;
  color: #000000;
  letter-spacing: 1px;
}
.itemText {
  font-family: sofiaProLight;
  font-size: 18px;
  color: #414141;
}
.itemCaption {
  font-family: sofiaProSemiBold;
  font-size: 20px;
  color: #1a1919;
}
.cardSubHeading {
  font-family: sofiaProMedium;
  font-size: 18px;
  color: #036917;
  letter-spacing: 1.5px;
}
</style>
